"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Root = exports.MobileCrumbHolder = exports.MobileArrowLeftThin = exports.Mobile = exports.DesktopArrowRightThin = exports.Desktop = exports.Crumb = exports.Breadcrumbs = void 0;
var _icons = require("@ori-ui/icons");
var _material = require("@ori-ui/mui-bundle/material");
var _react = require("react");
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
const Root = exports.Root = (0, _material.styled)(_material.Breadcrumbs)(({
  theme
}) => ({
  fontSize: theme.typography.caption.fontSize,
  color: theme.palette.text.primary
}));
const Desktop = exports.Desktop = (0, _material.styled)(Root)(({
  theme
}) => ({
  display: 'none',
  [theme.breakpoints.up('sm')]: {
    display: 'block'
  }
}));
const Mobile = exports.Mobile = (0, _material.styled)(Root)(({
  theme
}) => ({
  display: 'block',
  [theme.breakpoints.up('sm')]: {
    display: 'none'
  }
}));
const Crumb = exports.Crumb = (0, _material.styled)(_material.Link, {
  shouldForwardProp: (0, _utils.shouldNotForwardProp)(['isLast'])
})(({
  isLast
}) => ({
  color: 'inherit',
  fontWeight: isLast ? 'bold' : 'normal',
  textDecoration: 'none',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '90vw',
  '&:hover, &:focus': {
    color: 'inherit',
    fontWeight: isLast ? 'bold' : 'normal',
    textDecoration: 'underline'
  }
}));
const MobileCrumbHolder = exports.MobileCrumbHolder = (0, _material.styled)('span')(({
  theme
}) => ({
  display: 'grid',
  gridTemplateColumns: '18px auto',
  alignItems: 'center',
  gap: theme.spacing(1)
}));
const MobileArrowLeftThin = exports.MobileArrowLeftThin = (0, _material.styled)(_icons.ArrowLeftThin)({
  fontSize: '1.8rem'
});
const DesktopArrowRightThin = exports.DesktopArrowRightThin = (0, _material.styled)(_icons.ArrowRightThin)({
  fontSize: '1rem'
});
const Breadcrumbs = exports.Breadcrumbs = /*#__PURE__*/(0, _react.forwardRef)((inProps, ref) => {
  const props = (0, _material.useThemeProps)({
    props: inProps,
    name: 'MuiOriBreadcrumbs'
  });
  const {
    ariaLabel = 'breadcrumbs',
    breadcrumbs,
    dataTestId = 'breadcrumbs',
    disableMobileLayout = false,
    ...other
  } = props;
  const breadcrumbsLength = breadcrumbs.length;
  const previousSectionIndex = breadcrumbsLength < 2 ? 0 : breadcrumbsLength - 2;
  const previousSection = breadcrumbs[previousSectionIndex];
  const {
    ItemLabel: lastName = '',
    Url: previousSectionUrl = ''
  } = previousSection ?? {};
  if (breadcrumbsLength < 1) {
    return null;
  }
  if (disableMobileLayout) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(Root, {
      ref: ref,
      component: "nav",
      separator: /*#__PURE__*/(0, _jsxRuntime.jsx)(DesktopArrowRightThin, {
        "data-testid": `${dataTestId}-separator`
      }),
      "aria-label": ariaLabel,
      "data-testid": dataTestId,
      ...other,
      children: breadcrumbs.map(({
        ItemLabel,
        Url
      }, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(Crumb, {
        isLast: index === breadcrumbsLength - 1,
        href: Url,
        color: "inherit",
        "data-testid": `${dataTestId}-link-${index}`,
        children: ItemLabel
      }, Url))
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Mobile, {
      ref: ref,
      component: "nav",
      separator: /*#__PURE__*/(0, _jsxRuntime.jsx)(DesktopArrowRightThin, {
        "data-testid": `${dataTestId}-separator`
      }),
      "aria-label": `${ariaLabel}-mobile`,
      "data-testid": `${dataTestId}-mobile`,
      ...other,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(MobileCrumbHolder, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(MobileArrowLeftThin, {
          "data-testid": `${dataTestId}-arrow-left`
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Crumb, {
          isLast: true,
          href: previousSectionUrl,
          "data-testid": `${dataTestId}-mobile-link-${previousSectionIndex}`,
          children: lastName
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Desktop, {
      ref: ref,
      component: "nav",
      separator: /*#__PURE__*/(0, _jsxRuntime.jsx)(DesktopArrowRightThin, {
        "data-testid": `${dataTestId}-separator`
      }),
      "aria-label": ariaLabel,
      "data-testid": dataTestId,
      ...other,
      children: breadcrumbs.map(({
        ItemLabel,
        Url
      }, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(Crumb, {
        isLast: index === breadcrumbsLength - 1,
        href: Url,
        color: "inherit",
        "data-testid": `${dataTestId}-link-${index}`,
        children: ItemLabel
      }, Url))
    })]
  });
});
var _default = exports.default = Breadcrumbs;
//# sourceMappingURL=Breadcrumbs.js.map